/**
 * :ZNOTE:
 *  tag: トースト,通知,notification
 *  note:
 *  - トーストを出力するためのメソッドをexportしている
 *  - headlessなトーストモジュール"notiwind"を利用しており、App.vueにベースコンポーネントを組み込んでいて、そこにトーストを追加することができる
 *  - トーストのデザインやアニメーション、表示位置を変更したい場合は、ZNotificationBase.vueおよびZNotificationCard.vueを更新すれば良い
 *  sample:
 *  - @/components/toast/README.md
 *  - @/src/pages/auth/Login.vue
 *  - @/src/pages/auth/Login.vue
 * :ZNOTE:
 */


import {
  createNotifier,
  NotificationGroup,
  defineNotificationComponent,
} from 'notiwind';

export type NotificationSchema = {
  id?: string;          // 通知を一意に識別するためのID
  title: string;        // 見出し文字列
  text: string;         // 本文
  color?: string;       // 文字色(blue,green,yellow,orange,red,black)
  bgcolor?: string;     // 背景色(blue,green,yellow,orange,red,white)
  hasClose?: boolean;   // 閉じるボタンを表示したいならtrueにする
  component?: any;      // 任意のコンポーネントを表示することができる(閉じる機能が必要な場合は@closeをemitすること)
};

export const notify = createNotifier<NotificationSchema>();
export const Notification = defineNotificationComponent<NotificationSchema>();
export { NotificationGroup };
